import * as cfe from 'ego-cfe';
import * as api from 'ego-sdk-js';

import { useSelector } from 'react-redux';

import * as store from '../../state/store';

const useThreadRoot = (threadId: string) => {
  return useSelector<store.IAppState, cfe.ApiData.Data<api.thread.IGetTreeResult> | undefined>(
    state => state.apiCache.threadRoot.get(threadId)?.value,
  );
};

export default useThreadRoot;
